// Exports true if environment provides native `Map` implementation,
// whatever that is.

'use strict';

module.exports = (function () {
	if (typeof Map === 'undefined') return false;
	return (Object.prototype.toString.call(new Map()) === '[object Map]');
}());



//////////////////
// WEBPACK FOOTER
// ./~/es6-map/is-native-implemented.js
// module id = 840
// module chunks = 0